import { type FC } from "react";

import { DashboardScreen } from "./screen/DashboardScreen";

/**
 * DashboardApp - Entry point for the core dashboard feature
 *
 * @returns {JSX.Element} Dashboard application component
 *
 */
export const DashboardApp: FC = () => {
  return <DashboardScreen />;
};
